module.exports = __webpack_public_path__ + "public/img/baoxiugongdanchulishuju.1647b7a6.png";